<template>
  <div class="account-order">
    <div v-if="isMetaVisible" class="account-order__header">
      <div class="item account-order__date">
        {{ getOrderDate(order?.created_at) }}
      </div>

      <div class="item account-order__status">
        {{ order?.status }}
      </div>

      <div class="item account-order__title">#{{ order?.id }}</div>

      <div class="item account-order__total">
        {{ t('checkout.orderSummary.total') }}:
        {{ formatPriceAmount(order?.total?.amount, locale) }}
      </div>
    </div>

    <template v-for="item in order?.items?.data" :key="item.id">
      <AccountOrderItem
        v-if="item.orderStatus?.toUpperCase() !== 'CANCELED'"
        :order-item="item"
        :order-id="order.id"
        :has-customer-invoice="order.has_customer_invoice"
        :order-created-at="order.created_at"
        @invoice-success="handleInvoiceSuccess"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'

const { locale } = useI18n()
const { t } = useI18n()

const { order, isMetaVisible = true } = defineProps<{
  order: any
  isMetaVisible?: boolean
}>()

const emit = defineEmits<{
  'invoice-success': [
    data?: { has_customer_invoice: boolean; orderId?: string },
  ]
}>()

const handleInvoiceSuccess = (data?: { has_customer_invoice: boolean }) => {
  // Emit the invoice success with order ID so parent can update the correct order
  if (data?.has_customer_invoice) {
    emit('invoice-success', {
      has_customer_invoice: true,
      orderId: order.id,
    })
  } else {
    emit('invoice-success', data)
  }
}

const getOrderDate = (date: string) => {
  return dayjs(date).format('dd DD.MM.YYYY')
}
</script>

<style lang="postcss" scoped>
.account-order {
  &__header {
    @apply grid grid-cols-2 md:flex gap-2 justify-between border-t border-b border-secondary-active py-1.5;
    @apply text-sm text-gray-500 mb-2;
  }

  &__title,
  &__total {
    @apply text-right md:text-left;
  }
}
</style>
